import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 100 90'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M36,38.9996948 L47,26.9996948 L47,62.9996948 L36,51.9996948 L28,51.9996948 C26.9977679,51.9996948 26,51 26,49.9996948 L26,40.9996948 C26.0257074,39.9997006 27,39.0150136 28,38.9996948 L36,38.9996948 Z M51.5582623,48.0146932 L54.374716,45.1982395 L51.5248311,42.3483546 C50.8236543,41.6471779 50.8261933,40.5078068 51.5256318,39.8083683 L51.8062579,39.5277422 C52.5078769,38.8261233 53.6408096,38.8215069 54.3462442,39.5269415 L57.1961291,42.3768264 L60.0125828,39.5603727 C60.7144486,38.8585068 61.8524623,38.8585711 62.5520763,39.5581852 L62.7610887,39.7671976 C63.4617465,40.4678553 63.461421,41.6041713 62.7589012,42.3066911 L59.9424475,45.1231448 L62.8053866,47.9860839 C63.5052785,48.6859758 63.5016979,49.8243053 62.8022595,50.5237438 L62.5216334,50.8043699 C61.8200144,51.5059889 60.6856126,51.5091361 59.9839735,50.807497 L57.1210344,47.9445579 L54.3045807,50.7610116 C53.6027149,51.4628775 52.4647012,51.4628132 51.7650872,50.7631992 L51.5560747,50.5541867 C50.855417,49.853529 50.8557425,48.717213 51.5582623,48.0146932 Z'
    />
  </svg>
)

export default SVG